import {
  generateDatedSlots,
  generateDatesWithDayOfWeekFilter,
  isSlotOutsideBookingWindow,
} from 'app/ProviderSearch/utils'
import {
  DayOfWeek,
  INTAKE_BOOKING_WINDOW_HOURS,
  TimeOfDay,
} from 'constants/common'
import {
  getSlotWithTimeOfDayAdded,
  getSlotWithTimeOfDayHighlight,
} from './common'

type GetProviderSlotDetailsResult = {
  generatedSlots: DateSlot
  dates: (Date | null)[]
  count: number
}

export const getProviderSlotDetails = (
  providerDetails: Provider,
  providerSlots: NormalizedProviderSchedule,
  providerId: string,
  startSlotDate: Date,
  slotListLimit: number,
  counselingTypedFilters: ProviderFilter[],
  slotsRowLimit: number,
  timeOfDay: TimeOfDay[],
  timeZone: string,
  highlightOnlyTimeOfDay = false,
  dayOfWeek: DayOfWeek[] = [],
  bookingWindowHours: number = INTAKE_BOOKING_WINDOW_HOURS,
  extendedBookingEnabled = false
): GetProviderSlotDetailsResult => {
  const dateSlots: DateSlot = providerSlots[providerId] || {}
  const dates = generateDatesWithDayOfWeekFilter(
    startSlotDate,
    slotListLimit,
    dayOfWeek.length > 0 ? dayOfWeek : undefined,
    timeZone,
    extendedBookingEnabled
  )
  const datesForSlotRows = dates.filter((d): d is Date => d !== null)

  const generatedSlots = generateDatedSlots(
    datesForSlotRows,
    dateSlots,
    (slot: ProviderSlot) => {
      if (!isSlotOutsideBookingWindow(slot?.start, bookingWindowHours)) {
        return null
      } else if (timeOfDay.length > 0) {
        // When highlightOnlyTimeOfDay is true, add timeOfDay property but don't filter
        if (highlightOnlyTimeOfDay) {
          return getSlotWithTimeOfDayHighlight(slot, timeOfDay, timeZone)
        }

        return getSlotWithTimeOfDayAdded(slot, timeOfDay, timeZone)
      }

      return slot
    }
  )

  let shownSlotsCount = 0

  if (slotsRowLimit !== 0) {
    Object.keys(generatedSlots).map((slotDate) => {
      const slots = generatedSlots[slotDate]

      for (let index = 0; index < slotsRowLimit; index++) {
        const currentSlot = slots[index]
        const isPracticeMatching =
          currentSlot?.practiceId === providerDetails.practice.id

        if (isPracticeMatching) {
          shownSlotsCount++
        }
      }
    })
  }

  return {
    generatedSlots,
    dates,
    count: shownSlotsCount,
  }
}
